import { Alert, Box, Button, Group, Image, Modal, Text, useMantineTheme } from '@mantine/core'
import React, { useState } from 'react'

import { Feature as FeatureType } from '@/types'

interface Props {
  feature: FeatureType
  opened?: boolean
  onClose?: (feature: FeatureType) => void
}

export default function Popup({ feature, opened = false, onClose }: Props) {
  // Hooks
  const theme = useMantineTheme()

  // Constants
  const { persistent = false } = feature.config || {}

  // States
  const [manualOpen, setManualOpen] = useState(false)

  // Actions
  const close = () => {
    setManualOpen(false)
    onClose?.(feature)
  }

  const handleContentClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLElement)?.closest?.('#btn-comprar')) close()
  }

  return (
    <>
      {persistent && (
        <Alert variant="light" sx={{ border: `1px solid ${theme.colors[theme.primaryColor][2]}` }}>
          <Group position="apart">
            <Text fw="bold">{feature.title || 'Abrir popup'}</Text>
            <Button onClick={() => setManualOpen(true)}>Ver mais</Button>
          </Group>
        </Alert>
      )}
      <Modal
        opened={opened || manualOpen}
        onClose={close}
        title={feature.title}
        centered
        size="xl"
        withinPortal={false}
        lockScroll={false}
        zIndex={400}>
        {feature.image && (
          <Image src={feature.image} alt={feature.title} style={{ maxWidth: '100%' }} />
        )}
        <Box onClick={handleContentClick} dangerouslySetInnerHTML={{ __html: feature.content }} />
      </Modal>
    </>
  )
}
